// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-page {
  position: absolute;
  inset: 0;
  width: auto;
  height: auto;
  background-color: #e5e7eb;
  z-index: 0;
}

.map-content {
  width: 100%;
  height: 100%;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/pages/MapPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".map-page {\n  position: absolute;\n  inset: 0;\n  width: auto;\n  height: auto;\n  background-color: #e5e7eb;\n  z-index: 0;\n}\n\n.map-content {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
